import { MedicalItemsTab } from "@/Common/Models/Patient/PatientEnums";
import { QuebecVaccinationRegistryHelper } from "@/Patient/Components/MedicalItems/Immunization/QuebecVaccinationRegistryHelper";
import { PatientMedicalItemsHelper } from "@/Patient/Helpers/PatientMedicalItemsHelper";
import { MedicalItemImmunization } from "@/Patient/Models/MedicalSummary/MedicalItemImmunization";

interface IImmunizationSectionProps {
    immunizations: MedicalItemImmunization[];
    onMedicalItemClick: (model: MedicalItemImmunization, view: MedicalItemsTab) => void;
}

function ImmunizationSection(props: IImmunizationSectionProps): JSX.Element {
    return (
        <>
            {props.immunizations?.map(
                (immunization, idx) => {
                    const refusedDateString = immunization.RefusedDate != null
                        ? `(${PatientMedicalItemsHelper.GetLifeStageDateString(immunization.RefusedDate, immunization.RefusedPrecisionDate)})`
                        : "";
                    const administrationDateString = immunization.AdministeredDate != null
                        ? `(${PatientMedicalItemsHelper.GetLifeStageDateString(immunization.AdministeredDate, immunization.AdministeredPrecisionDate)})`
                        : "";
                    const immunizationDisplayName = QuebecVaccinationRegistryHelper.getImmunizationDisplayName(immunization);
                    const isLast = idx === (props.immunizations.length - 1);

                    return (
                        <a
                            key={immunization.Id}
                            onClick={() => props.onMedicalItemClick(immunization, MedicalItemsTab.Immunization)}
                            style={{ marginRight: isLast ? "0" : "5px" }}
                            data-cy="immunization-item"
                        >
                            {immunizationDisplayName} {(immunization.IsRefused ? refusedDateString : administrationDateString)}
                            {!isLast && ","}
                        </a>
                    );
                }
            )}
        </>
    );
}

export { ImmunizationSection };
